import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=3a73bc1e&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a73bc1e')) {
      api.createRecord('3a73bc1e', component.options)
    } else {
      api.reload('3a73bc1e', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=3a73bc1e&", function () {
      api.rerender('3a73bc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Account/Widgets/Notifications.vue"
export default component.exports